import { render, staticRenderFns } from "./AcceptInvitation.vue?vue&type=template&id=3bf6a04e&scoped=true"
import script from "./AcceptInvitation.vue?vue&type=script&lang=js"
export * from "./AcceptInvitation.vue?vue&type=script&lang=js"
import style0 from "./AcceptInvitation.vue?vue&type=style&index=0&id=3bf6a04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf6a04e",
  null
  
)

export default component.exports